export default __webpack_public_path__ + "static/media/banner-bg-ir-2024-hp.8f6a8ee9.jpg";